<template>
  <b-modal
    id="claimConfirmationModal"
    ref="claimConfirmationModal"
    hide-footer
    hide-header
    size="xl"
  >
    <div class="modal-container">
      {{ `${numberOfSelected} Added` }}
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
.modal-container {
  background-color: black;
  opacity: 0.8;
  padding: 16px;
  margin: -14px;
  color: white;
}
</style>


<script>
export default {
  props: {
    numberOfSelected: { type: Number }
  }
}
</script>
